// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imagesBacklog_uhm_v {
  margin-left: 20px;
}
.imagesBacklog2_pIQ1o {
  margin-top: 13px;
}
.btnStartQaComlete_onUtZ {
  margin-top: 14px;
}
.createTaskBtn_YvA8Q {
  margin-left: 1100px;
}
.todoCard_mX74T {
  width: 97%;
  overflow: hidden;
  word-break: break-word;
  background-color: rgba(241, 234, 234, 0.699);
  margin-bottom: 5px;
}
.todoIcons_ay1Ow {
  font-size: 20px;
  margin-right: 10px;
}
.iconContainer_B_0zg {
  background-color: #f7f1f1;
  padding: 16px;
  padding-left: 15px;
  padding-right: 12px;
}
.todoAllIconContainer_mxnaB {
  display: flex;
  align-items: center;
}
.todoItem_Tz7bl {
  margin-bottom: 8px;
}
.todoAvatarContainer_dAdOM {
  margin-left: 200px;
  display: flex;
  align-items: center;
  font-size: 10px;
}
.addTaskCard_xn93T {
  width: 98%;
  overflow: hidden;
  word-break: break-word;
  background-color: #d3d3d3;
}
.addTaskIconCol_PdzAO {
  font-size: 18px;
}
.addTaskIcon_pUh_K {
  margin-right: 5px;
}
.attachmentDiv_abMan {
  background-color: #a5a5a5;
  padding: 2px;
}
.textFunctionality_u7ZLV {
  display: flex;
  align-items: center;
  font-size: 20px;
  border: 1px solid;
  border-color: black;
}
.textFunctionalityDiv_LTFuh {
  margin-right: 7px;
  margin-left: 7px;
}
.reactQuillTodoList_dJIMu {
  width: 780px;
}
.allCommentsHistory_axO6C {
  display: flex;
  align-items: center;
  background-color: gray;
  margin-right: 5px;
  padding: 2px;
  padding-left: 8px;
  padding-right: 8px;
}
.list_pzdYm {
  display: flex;
  /* Use flexbox */
  flex-wrap: wrap;
  /* Allow items to wrap to the next line if needed */
  justify-content: flex-start;
  /* Align items from left to right */
  gap: 16px;
  /* Space between items */
}
.addTaskIconColField_sFY28 {
  margin-left: 14px;
}
.addTaskIconColSwitch_qIfY1 {
  margin-left: -5px;
}
.addTaskIconColStaff_FTpnR {
  margin-left: 4px;
}
.tasknameStyles_O1Yo3 {
  border-bottom: dotted 1px;
  margin-bottom: 10px;
  border-color: gray;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.circle_e6v9r {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-left: 5px;
  background-color: red;
  margin-top: 7px;
  padding-left: 5px;
}
.filterCircleColor_CgtQm {
  display: flex;
  justify-content: space-between;
  margin-left: 700px;
}
.mainRow_isg5V {
  display: flex;
  flex-direction: row;
}
.sprintListContainer_t1PIb {
  display: flex;
  align-items: center;
}
.sprintListElipseStyle_VkKan {
  font-size: 24px;
  margin-left: 10px;
}
.backlogHeaderContainerdiv_LJX2P {
  width: 100%;
  margin-bottom: 10px;
}
.backlogHeaderContainer_SqmjV:active {
  color: gray;
}
.BacklogHeader_VPJ2g {
  display: flex;
  justify-content: space-between;
}
.formOutlineBackogCollapse_DzBJN {
  margin-left: 10px;
}
.sprintBackListTable_x0NA_ {
  margin-top: -20px;
}
.sprintListoutStyles_bPxmv {
  width: 100%;
  margin-bottom: 5px;
}
.sprintListCollapsePanel_O8LPE {
  margin-bottom: 10px;
  width: 100%;
}
.backlogColumnDiv_yzrtJ {
  display: flex;
}
.editOutLinedSprintList_WXPzT {
  margin-left: 10px;
}
.startSprintButtonSprintList_Aj1Al {
  display: flex;
  margin-left: 650px;
  margin-top: 10px;
}
.EllipsisOutlinedSprintList_y9RDW {
  font-size: 20px;
  margin-top: 8px;
}
.taskAndColor_ldpBV {
  display: flex;
  justify-content: space-between;
}
.todoAssignAvatar_Nl0n7 {
  display: flex;
  margin-right: 2px;
  justify-content: space-between;
}
.todotaskassignedname_jcFap {
  margin-top: 7px;
  margin-right: 4px;
}
.chatSearchMain_li7Qi {
  background-color: #085394;
  padding-bottom: 20px;
}
.chatSearchDiv_bkodE {
  margin-left: 10px;
}
.chatListItem_UyeJK {
  padding: 80px;
  transition: background-color 0.3s ease;
  margin-left: 15px;
}
.chatListItem_UyeJK :hover {
  background-color: #a0c4db;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BackLog/backLogList.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,gBAAA;AAFJ;AAKA;EACI,mBAAA;AAHJ;AAMA;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,4CAAA;EACA,kBAAA;AAJJ;AAOA;EACI,eAAA;EACA,kBAAA;AALJ;AAQA;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AANJ;AASA;EACI,aAAA;EACA,mBAAA;AAPJ;AAUA;EACI,kBAAA;AARJ;AAWA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AATJ;AAYA;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAVJ;AAaA;EACI,eAAA;AAXJ;AAcA;EACI,iBAAA;AAZJ;AAeA;EACI,yBAAA;EACA,YAAA;AAbJ;AAgBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAdJ;AAiBA;EACI,iBAAA;EACA,gBAAA;AAfJ;AAkBA;EACI,YAAA;AAhBJ;AAmBA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAjBJ;AAoBA;EACI,aAAA;EAlBF,gBAAgB;EAmBd,eAAA;EAjBF,mDAAmD;EAkBjD,2BAAA;EAhBF,mCAAmC;EAiBjC,SAAA;EAfF,wBAAwB;AAC1B;AAiBA;EACI,iBAAA;AAfJ;AAkBA;EACI,iBAAA;AAhBJ;AAmBA;EACI,gBAAA;AAjBJ;AAoBA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAlBJ;AAqBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAnBJ;AAsBA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AApBJ;AAuBA;EACI,aAAA;EACA,mBAAA;AArBJ;AAwBA;EACI,aAAA;EACA,mBAAA;AAtBJ;AAyBA;EACI,eAAA;EACA,iBAAA;AAvBJ;AA0BA;EACI,WAAA;EACA,mBAAA;AAxBJ;AA2BA;EACI,WAAA;AAzBJ;AA4BA;EACI,aAAA;EACA,8BAAA;AA1BJ;AA6BA;EACI,iBAAA;AA3BJ;AA8BA;EACI,iBAAA;AA5BJ;AA+BA;EACI,WAAA;EACA,kBAAA;AA7BJ;AAgCA;EACI,mBAAA;EACA,WAAA;AA9BJ;AAiCA;EACI,aAAA;AA/BJ;AAkCA;EACI,iBAAA;AAhCJ;AAmCA;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;AAjCJ;AAoCA;EACI,eAAA;EACA,eAAA;AAlCJ;AAqCA;EACI,aAAA;EACA,8BAAA;AAnCJ;AAsCA;EACI,aAAA;EACA,iBAAA;EACA,8BAAA;AApCJ;AAuCA;EACI,eAAA;EACA,iBAAA;AArCJ;AAwCA;EACI,yBAAA;EAEA,oBAAA;AAvCJ;AA0CA;EACI,iBAAA;AAxCJ;AA2CA;EACI,aAAA;EACA,sCAAA;EACA,iBAAA;AAzCJ;AA4CA;EACI,yBAAA;EACA,eAAA;AA1CJ","sourcesContent":[".imagesBacklog {\n    margin-left: 20px;\n    // margin-right: 20px;\n}\n\n.imagesBacklog2 {\n    margin-top: 13px;\n}\n\n.btnStartQaComlete {\n    margin-top: 14px;\n}\n\n.createTaskBtn {\n    margin-left: 1100px;\n}\n\n.todoCard {\n    width: 97%;\n    overflow: hidden;\n    word-break: break-word;\n    background-color: rgba(241, 234, 234, 0.699);\n    margin-bottom: 5px;\n}\n\n.todoIcons {\n    font-size: 20px;\n    margin-right: 10px;\n}\n\n.iconContainer {\n    background-color: rgb(247, 241, 241);\n    padding: 16px;\n    padding-left: 15px;\n    padding-right: 12px;\n}\n\n.todoAllIconContainer {\n    display: flex;\n    align-items: center;\n}\n\n.todoItem {\n    margin-bottom: 8px;\n}\n\n.todoAvatarContainer {\n    margin-left: 200px;\n    display: flex;\n    align-items: center;\n    font-size: 10px;\n}\n\n.addTaskCard {\n    width: 98%;\n    overflow: hidden;\n    word-break: break-word;\n    background-color: rgb(211, 211, 211);\n}\n\n.addTaskIconCol {\n    font-size: 18px;\n}\n\n.addTaskIcon {\n    margin-right: 5px;\n}\n\n.attachmentDiv {\n    background-color: rgb(165, 165, 165);\n    padding: 2px;\n}\n\n.textFunctionality {\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    border: 1px solid;\n    border-color: black;\n}\n\n.textFunctionalityDiv {\n    margin-right: 7px;\n    margin-left: 7px;\n}\n\n.reactQuillTodoList {\n    width: 780px;\n}\n\n.allCommentsHistory {\n    display: flex;\n    align-items: center;\n    background-color: gray;\n    margin-right: 5px;\n    padding: 2px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.list {\n    display: flex; /* Use flexbox */\n    flex-wrap: wrap; /* Allow items to wrap to the next line if needed */\n    justify-content: flex-start; /* Align items from left to right */\n    gap: 16px; /* Space between items */\n}\n\n.addTaskIconColField {\n    margin-left: 14px;\n}\n\n.addTaskIconColSwitch {\n    margin-left: -5px;\n}\n\n.addTaskIconColStaff {\n    margin-left: 4px;\n}\n\n.tasknameStyles {\n    border-bottom: dotted 1px;\n    margin-bottom: 10px;\n    border-color: gray;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.circle {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-left: 5px;\n    background-color: red;\n    margin-top: 7px;\n    padding-left: 5px;\n}\n\n.filterCircleColor {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 700px;\n}\n\n.mainRow {\n    display: flex;\n    flex-direction: row;\n}\n\n.sprintListContainer {\n    display: flex;\n    align-items: center;\n}\n\n.sprintListElipseStyle {\n    font-size: 24px;\n    margin-left: 10px;\n}\n\n.backlogHeaderContainerdiv {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.backlogHeaderContainer:active {\n    color: gray;\n}\n\n.BacklogHeader {\n    display: flex;\n    justify-content: space-between;\n}\n\n.formOutlineBackogCollapse {\n    margin-left: 10px;\n}\n\n.sprintBackListTable {\n    margin-top: -20px;\n}\n\n.sprintListoutStyles {\n    width: 100%;\n    margin-bottom: 5px;\n}\n\n.sprintListCollapsePanel {\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.backlogColumnDiv {\n    display: flex;\n}\n\n.editOutLinedSprintList {\n    margin-left: 10px;\n}\n\n.startSprintButtonSprintList {\n    display: flex;\n    margin-left: 650px;\n    margin-top: 10px;\n}\n\n.EllipsisOutlinedSprintList {\n    font-size: 20px;\n    margin-top: 8px;\n}\n\n.taskAndColor {\n    display: flex;\n    justify-content: space-between;\n}\n\n.todoAssignAvatar {\n    display: flex;\n    margin-right: 2px;\n    justify-content: space-between;\n}\n\n.todotaskassignedname {\n    margin-top: 7px;\n    margin-right: 4px;\n}\n\n.chatSearchMain {\n    background-color: rgb(8, 83, 148);\n    // padding-top: 30px;\n    padding-bottom: 20px;\n}\n\n.chatSearchDiv {\n    margin-left: 10px;\n}\n\n.chatListItem {\n    padding: 80px;\n    transition: background-color 0.3s ease;\n    margin-left: 15px;\n}\n\n.chatListItem :hover {\n    background-color: #a0c4db;\n    cursor: pointer;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imagesBacklog": `imagesBacklog_uhm_v`,
	"imagesBacklog2": `imagesBacklog2_pIQ1o`,
	"btnStartQaComlete": `btnStartQaComlete_onUtZ`,
	"createTaskBtn": `createTaskBtn_YvA8Q`,
	"todoCard": `todoCard_mX74T`,
	"todoIcons": `todoIcons_ay1Ow`,
	"iconContainer": `iconContainer_B_0zg`,
	"todoAllIconContainer": `todoAllIconContainer_mxnaB`,
	"todoItem": `todoItem_Tz7bl`,
	"todoAvatarContainer": `todoAvatarContainer_dAdOM`,
	"addTaskCard": `addTaskCard_xn93T`,
	"addTaskIconCol": `addTaskIconCol_PdzAO`,
	"addTaskIcon": `addTaskIcon_pUh_K`,
	"attachmentDiv": `attachmentDiv_abMan`,
	"textFunctionality": `textFunctionality_u7ZLV`,
	"textFunctionalityDiv": `textFunctionalityDiv_LTFuh`,
	"reactQuillTodoList": `reactQuillTodoList_dJIMu`,
	"allCommentsHistory": `allCommentsHistory_axO6C`,
	"list": `list_pzdYm`,
	"addTaskIconColField": `addTaskIconColField_sFY28`,
	"addTaskIconColSwitch": `addTaskIconColSwitch_qIfY1`,
	"addTaskIconColStaff": `addTaskIconColStaff_FTpnR`,
	"tasknameStyles": `tasknameStyles_O1Yo3`,
	"circle": `circle_e6v9r`,
	"filterCircleColor": `filterCircleColor_CgtQm`,
	"mainRow": `mainRow_isg5V`,
	"sprintListContainer": `sprintListContainer_t1PIb`,
	"sprintListElipseStyle": `sprintListElipseStyle_VkKan`,
	"backlogHeaderContainerdiv": `backlogHeaderContainerdiv_LJX2P`,
	"backlogHeaderContainer": `backlogHeaderContainer_SqmjV`,
	"BacklogHeader": `BacklogHeader_VPJ2g`,
	"formOutlineBackogCollapse": `formOutlineBackogCollapse_DzBJN`,
	"sprintBackListTable": `sprintBackListTable_x0NA_`,
	"sprintListoutStyles": `sprintListoutStyles_bPxmv`,
	"sprintListCollapsePanel": `sprintListCollapsePanel_O8LPE`,
	"backlogColumnDiv": `backlogColumnDiv_yzrtJ`,
	"editOutLinedSprintList": `editOutLinedSprintList_WXPzT`,
	"startSprintButtonSprintList": `startSprintButtonSprintList_Aj1Al`,
	"EllipsisOutlinedSprintList": `EllipsisOutlinedSprintList_y9RDW`,
	"taskAndColor": `taskAndColor_ldpBV`,
	"todoAssignAvatar": `todoAssignAvatar_Nl0n7`,
	"todotaskassignedname": `todotaskassignedname_jcFap`,
	"chatSearchMain": `chatSearchMain_li7Qi`,
	"chatSearchDiv": `chatSearchDiv_bkodE`,
	"chatListItem": `chatListItem_UyeJK`
};
export default ___CSS_LOADER_EXPORT___;
